import type { BootstrapData } from '@/types'
import { createContext } from 'react'

const BootstrapDataContext = createContext<BootstrapData>({} as BootstrapData)

export default BootstrapDataContext
